import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  RevenueRecognitionActionPayload,
  updateRevenueRecognitionAction,
} from '../actions';
import { updateRecognitionConfigAction } from '../slices';

function* updateMilestoneRevenueRecognitionAction(
  action: StoreActionProps<RevenueRecognitionActionPayload>,
) {
  try {
    const {
      payload: { milestoneRevenueRecognitionConfigs },
    } = action;

    yield put(
      updateRecognitionConfigAction({ milestoneRevenueRecognitionConfigs }),
    );
  } catch (error) {
    logger.error('an error on updating revenue recognition in template', {
      error,
    });
  }
}
export function* watchMilestoneRecognisedRevenueActionSaga(): Generator {
  yield takeLatest(
    updateRevenueRecognitionAction.type,
    updateMilestoneRevenueRecognitionAction,
  );
}
